<template>
<div>
    <div class="crumbs">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <i class="el-icon-lx-cascades"></i> {{$t('pages.frequency.breadcrumb')}}
            </el-breadcrumb-item>
        </el-breadcrumb>
    </div>

    <div class="container">
        <div>
            <div class="handle-headleft">
                <el-button type="primary" icon="el-icon-circle-plus-outline" @click="handleAdd">{{$t('pages.frequency.add')}}</el-button>
                <el-button type="danger" icon="el-icon-delete" @click="delAllSelection">{{$t('pages.frequency.delete')}}</el-button>
            </div>
            <div class="handle-headright">
                <el-input v-model="query.Field1" @blur="getData()" class="handle-select mr10" :placeholder="$t('pages.frequency.namePh')"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="getData">{{$t('pages.frequency.search')}}</el-button>
            </div>
        </div>
        <el-table :data="frequencys" border class="table" ref="multipleTable" :element-loading-text="$t('pages.frequency.loading')" v-loading="loading" header-cell-class-name="table-header" @selection-change="handleSelectionChange" @row-dblclick="dbSelected">
            <el-table-column type="selection" width="55" align="center"></el-table-column>
            <el-table-column type="index" width="50" :label="$t('pages.frequency.index')"></el-table-column>
            <el-table-column sortable prop="name" :label="$t('pages.frequency.planName')"></el-table-column>
            <el-table-column sortable prop="pName1" :label="$t('pages.frequency.shift1Name')"></el-table-column>
            <el-table-column prop="startTime1" :label="$t('pages.frequency.shift1Start')"></el-table-column>
            <el-table-column prop="endTime1" :label="$t('pages.frequency.shift1End')"></el-table-column>
            <!-- <el-table-column prop="modifyUserId" label="操作人"></el-table-column> -->
            <el-table-column sortable prop="modifyDate" :label="$t('pages.frequency.modifyTime')" width="140">
                <template slot-scope="scope">{{ scope.row.modifyDate | formateData }}</template>
            </el-table-column>
            <el-table-column :label="$t('pages.frequency.operation')" width="110" align="center">
                <template slot-scope="scope">
                    <!-- <el-button type="text" icon="el-icon-tickets" @click="handleShow(scope.row.id, scope.row)">查看 </el-button> -->
                    <el-button type="text" icon="el-icon-edit" @click="handleEdit(scope.row.id, scope.row)">{{$t('pages.frequency.edit')}}</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination background layout="total, prev, pager, next" :current-page="query.PageIndex" :page-size="query.PageSize" :total="pageCount" @current-change="handlePageChange"></el-pagination>
        </div>
    </div>
    <!-- 编辑弹出框 -->
    <el-dialog :title="headTitle" :visible.sync="editVisible" width="50%" :close-on-click-modal="false">
        <el-form ref="frequency" :model="frequency" :rules="rules" label-width="90px">
            <el-row>
                <el-col :span="6">
                    <el-form-item :label="$t('pages.frequency.planName')" prop="name">
                        <el-input v-model="frequency.name"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item :label="$t('pages.frequency.shiftCount')" prop="count">
                        <el-input v-model="frequency.frequencyCount"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item>
                        <el-switch v-model="frequency.isCustomSettlementDate" :active-text="$t('pages.frequency.customSettlementOn')" :inactive-text="$t('pages.frequency.customSettlementOff')"></el-switch>
                    </el-form-item>
                </el-col>
                <el-col :span="4" v-show="frequency.isCustomSettlementDate == true ? true : false ">
                    <el-form-item :label="$t('pages.frequency.eachMonth')">
                        <el-input v-model="frequency.settlementDate"></el-input>
                    </el-form-item>

                </el-col>

            </el-row>

            <el-row>
                <el-col :span="5">
                    <el-form-item :label="$t('pages.frequency.shiftName')" prop="pName1">
                        <el-input v-model="frequency.pName1" class="size-full"></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="5">
                    <el-form-item :label="$t('pages.frequency.startTime')" prop="StartTime1">
                        <el-time-picker v-model="frequency.startTime1" format="HH:mm" value-format="HH:mm" :placeholder="$t('pages.frequency.startTimePh')" class="size-full"></el-time-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="2">
                    <el-select v-model="frequency.whichDayS1" class="size-full" prop="whichDayS1">
                        <el-option v-for="item in whichDayS1" :key="item.value" :label="$t(item.name)" :value="item.value"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="5">
                    <el-form-item :label="$t('pages.frequency.endTime')" prop="endTime1">
                        <el-time-picker v-model="frequency.endTime1" format="HH:mm" value-format="HH:mm" :placeholder="$t('pages.frequency.endTimePh')" class="size-full"></el-time-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="2">
                    <el-select v-model="frequency.whichDayE1" class="size-full" prop="whichDayE1">
                        <el-option v-for="item in whichDayE1" :key="item.value" :label="$t(item.name)" :value="item.value"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="3">
                    <el-form-item :label="$t('pages.frequency.enabled')" prop="enabled1">
                        <el-switch v-model="frequency.enabled1"></el-switch>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="5">
                    <el-form-item :label="$t('pages.frequency.shiftName')" prop="pName2">
                        <el-input v-model="frequency.pName2" class="size-full"></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="5">
                    <el-form-item :label="$t('pages.frequency.startTime')" prop="StartTime2">
                        <el-time-picker v-model="frequency.startTime2" format="HH:mm" value-format="HH:mm" :placeholder="$t('pages.frequency.startTimePh')" class="size-full"></el-time-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="2">
                    <el-select v-model="frequency.whichDayS2" class="size-full">
                        <el-option v-for="item in whichDayS2" :key="item.value" :label="$t(item.name)" :value="item.value"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="5">
                    <el-form-item :label="$t('pages.frequency.endTime')" prop="endTime2">
                        <el-time-picker v-model="frequency.endTime2" format="HH:mm" value-format="HH:mm" :placeholder="$t('pages.frequency.endTimePh')" class="size-full"></el-time-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="2">
                    <el-select v-model="frequency.whichDayE2" class="size-full">
                        <el-option v-for="item in whichDayE2" :key="item.value" :label="$t(item.name)" :value="item.value"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="3">
                    <el-form-item :label="$t('pages.frequency.enabled')" prop="enabled2">
                        <el-switch v-model="frequency.enabled2"></el-switch>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="5">
                    <el-form-item :label="$t('pages.frequency.shiftName')" prop="pName3">
                        <el-input v-model="frequency.pName3" class="size-full"></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="5">
                    <el-form-item :label="$t('pages.frequency.startTime')" prop="StartTime3">
                        <el-time-picker v-model="frequency.startTime3" format="HH:mm" value-format="HH:mm" :placeholder="$t('pages.frequency.startTimePh')" class="size-full"></el-time-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="2">
                    <el-select v-model="frequency.whichDayS3" class="size-full">
                        <el-option v-for="item in whichDayS3" :key="item.value" :label="$t(item.name)" :value="item.value"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="5">
                    <el-form-item :label="$t('pages.frequency.endTime')" prop="endTime3">
                        <el-time-picker v-model="frequency.endTime3" format="HH:mm" value-format="HH:mm" :placeholder="$t('pages.frequency.endTimePh')" class="size-full"></el-time-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="2">
                    <el-select v-model="frequency.whichDayE3" class="size-full">
                        <el-option v-for="item in whichDayE3" :key="item.value" :label="$t(item.name)" :value="item.value"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="3">
                    <el-form-item :label="$t('pages.frequency.enabled')" prop="enabled3">
                        <el-switch v-model="frequency.enabled3"></el-switch>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="5">
                    <el-form-item :label="$t('pages.frequency.shiftName')" prop="pName4">
                        <el-input v-model="frequency.pName4" class="size-full"></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="5">
                    <el-form-item :label="$t('pages.frequency.startTime')" prop="StartTime4">
                        <el-time-picker v-model="frequency.startTime4" format="HH:mm" value-format="HH:mm" :placeholder="$t('pages.frequency.startTimePh')" class="size-full"></el-time-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="2">
                    <el-select v-model="frequency.whichDayS4" class="size-full">
                        <el-option v-for="item in whichDayS4" :key="item.value" :label="$t(item.name)" :value="item.value"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="5">
                    <el-form-item :label="$t('pages.frequency.endTime')" prop="endTime4">
                        <el-time-picker v-model="frequency.endTime4" format="HH:mm" value-format="HH:mm" :placeholder="$t('pages.frequency.endTimePh')" class="size-full"></el-time-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="2">
                    <el-select v-model="frequency.whichDayE4" class="size-full">
                        <el-option v-for="item in whichDayE4" :key="item.value" :label="$t(item.name)" :value="item.value"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="3">
                    <el-form-item :label="$t('pages.frequency.enabled')" prop="enabled4">
                        <el-switch v-model="frequency.enabled4"></el-switch>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="5">
                    <el-form-item :label="$t('pages.frequency.shiftName')" prop="pName5">
                        <el-input v-model="frequency.pName5" class="size-full"></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="5">
                    <el-form-item :label="$t('pages.frequency.startTime')" prop="StartTime5">
                        <el-time-picker v-model="frequency.startTime5" format="HH:mm" value-format="HH:mm" :placeholder="$t('pages.frequency.startTimePh')" class="size-full"></el-time-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="2">
                    <el-select v-model="frequency.whichDayS5" class="size-full">
                        <el-option v-for="item in whichDayS5" :key="item.value" :label="$t(item.name)" :value="item.value"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="5">
                    <el-form-item :label="$t('pages.frequency.endTime')" prop="endTime5">
                        <el-time-picker v-model="frequency.endTime5" format="HH:mm" value-format="HH:mm" :placeholder="$t('pages.frequency.endTimePh')" class="size-full"></el-time-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="2">
                    <el-select v-model="frequency.whichDayE5" class="size-full">
                        <el-option v-for="item in whichDayE5" :key="item.value" :label="$t(item.name)" :value="item.value"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="3">
                    <el-form-item :label="$t('pages.frequency.enabled')" prop="enabled5">
                        <el-switch v-model="frequency.enabled5"></el-switch>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-col :span="7">
                <el-form-item :label="$t('pages.frequency.loopStart')" prop="dayStartTime" label-width="150px">
                    <el-time-picker v-model="frequency.dayStartTime" format="HH:mm" value-format="HH:mm" :placeholder="$t('pages.frequency.startTimePh')" class="size-full"></el-time-picker>
                </el-form-item>
            </el-col>
            <el-col :span="2">
                    <el-select v-model="frequency.startWhichDay" class="size-full">
                        <el-option v-for="item in startWhichDay" :key="item.value" :label="$t(item.name)" :value="item.value"></el-option>
                    </el-select>
                </el-col>
            <el-col :span="7">
                <el-form-item :label="$t('pages.frequency.loopEnd')" prop="dayEndTime" label-width="150px">
                    <el-time-picker v-model="frequency.dayEndTime" format="HH:mm" value-format="HH:mm" :placeholder="$t('pages.frequency.endTimePh')" class="size-full"></el-time-picker>
                </el-form-item>
            </el-col>
             <el-col :span="2">
                    <el-select v-model="frequency.endWhichDay" class="size-full">
                        <el-option v-for="item in endWhichDay" :key="item.value" :label="$t(item.name)" :value="item.value"></el-option>
                    </el-select>
                </el-col>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="editVisible = false">{{$t('pages.frequency.cancel')}}</el-button>
            <el-button type="primary" @click="saveEdit('frequency')">{{$t('pages.frequency.confirm')}}</el-button>
        </span>
    </el-dialog>

    <!-- 查看弹出框 -->
    <el-dialog :title="$t('pages.frequency.viewTitle')" :visible.sync="viewVisible" width="50%" :close-on-click-modal="false">
        <el-form ref="frequency" :model="frequency" :rules="rules" label-width="90px">
            <el-row>
                <el-col :span="12">
                    <el-form-item :label="$t('pages.frequency.planName')" prop="name">
                        <span v-text="frequency.name"></span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item :label="$t('pages.frequency.shiftCount')" prop="count">
                        <span v-text="frequency.frequencyCount"></span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6">
                    <el-form-item :label="$t('pages.frequency.shiftName1')" prop="pName1">
                        <span v-text="frequency.pName1"></span>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item :label="$t('pages.frequency.startTime')" prop="startTime1">
                        <span v-text="frequency.startTime1"></span>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item :label="$t('pages.frequency.endTime')" prop="endTime1">
                        <span v-text="frequency.endTime1"></span>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item :label="$t('pages.frequency.enabled')" prop="enabled1">
                        <span>{{ frequency.enabled1 == 1 ? $t('pages.frequency.yes') : $t('pages.frequency.no') }}</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6">
                    <el-form-item :label="$t('pages.frequency.shiftName2')" prop="pName2">
                        <span v-text="frequency.pName2"></span>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item :label="$t('pages.frequency.startTime')" prop="startTime2">
                        <span v-text="frequency.startTime2"></span>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item :label="$t('pages.frequency.endTime')" prop="endTime2">
                        <span v-text="frequency.endTime2"></span>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item :label="$t('pages.frequency.enabled')" prop="enabled2">
                        <span>{{ frequency.enabled2 == 1 ? $t('pages.frequency.yes') : $t('pages.frequency.no') }}</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6">
                    <el-form-item :label="$t('pages.frequency.shiftName3')" prop="pName3">
                        <span v-text="frequency.pName3"></span>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item :label="$t('pages.frequency.startTime')" prop="startTime3">
                        <span v-text="frequency.startTime3"></span>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item :label="$t('pages.frequency.endTime')" prop="endTime3">
                        <span v-text="frequency.endTime3"></span>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item :label="$t('pages.frequency.enabled')" prop="enabled3">
                        <span>{{ frequency.enabled3 == 1 ? $t('pages.frequency.yes') : $t('pages.frequency.no') }}</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6">
                    <el-form-item :label="$t('pages.frequency.shiftName4')" prop="pName4">
                        <span v-text="frequency.pName4"></span>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item :label="$t('pages.frequency.startTime')" prop="startTime4">
                        <span v-text="frequency.startTime4"></span>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item :label="$t('pages.frequency.endTime')" prop="endTime4">
                        <span v-text="frequency.endTime4"></span>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item :label="$t('pages.frequency.enabled')" prop="enabled4">
                        <span>{{ frequency.enabled4 == 1 ? $t('pages.frequency.yes') : $t('pages.frequency.no') }}</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6">
                    <el-form-item :label="$t('pages.frequency.shiftName5')" prop="pName5">
                        <span v-text="frequency.pName5"></span>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item :label="$t('pages.frequency.startTime')" prop="startTime5">
                        <span v-text="frequency.startTime5"></span>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item :label="$t('pages.frequency.endTime')" prop="endTime5">
                        <span v-text="frequency.endTime5"></span>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item :label="$t('pages.frequency.enabled')" prop="enabled5">
                        <span>{{ frequency.enabled5 == 1 ? $t('pages.frequency.yes') : $t('pages.frequency.no') }}</span>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="viewVisible = false">{{$t('pages.frequency.close')}}</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
import {
    SortField
} from '../../utils/helper';
let that;
export default {
    name: 'frequency',
    data: function () {
        return {
            balanceArr: [],
            headTitle: '',
            viewVisible: false,
            isadd: false,
            frequency: {},
            editVisible: false,
            frequencys: [],
            pageCount: 1,
            multipleSelection: [],
            delList: [],
            loading: false,
            query: {
                Field1: '',
                PageIndex: 1,
                PageSize: 15
            },
            rules: {
                startTime: [{
                    required: true,
                    message: this.$t('pages.frequency.valid.startTimeRequired'),
                    trigger: 'blur'
                }],
                name: [{
                    required: true,
                    message: this.$t('pages.frequency.valid.nameRequired'),
                    trigger: 'blur'
                }],
                endTime: [{
                    required: true,
                    message: this.$t('pages.frequency.valid.endTimeRequired'),
                    trigger: 'blur'
                }]
            },
            whichDayS1: [{
                name: 'pages.frequency.day.prev',
                value: 0
            }, {
                name: 'pages.frequency.day.today',
                value: 1
            }, {
                name: 'pages.frequency.day.next',
                value: 2
            }, ],
            whichDayE1: [{
                name: 'pages.frequency.day.prev',
                value: 0
            }, {
                name: 'pages.frequency.day.today',
                value: 1
            }, {
                name: 'pages.frequency.day.next',
                value: 2
            }, ],
            whichDayS2: [{
                name: 'pages.frequency.day.prev',
                value: 0
            }, {
                name: 'pages.frequency.day.today',
                value: 1
            }, {
                name: 'pages.frequency.day.next',
                value: 2
            }, ],
            whichDayE2: [{
                name: 'pages.frequency.day.prev',
                value: 0
            }, {
                name: 'pages.frequency.day.today',
                value: 1
            }, {
                name: 'pages.frequency.day.next',
                value: 2
            }, ],
            whichDayS3: [{
                name: 'pages.frequency.day.prev',
                value: 0
            }, {
                name: 'pages.frequency.day.today',
                value: 1
            }, {
                name: 'pages.frequency.day.next',
                value: 2
            }, ],
            whichDayE3: [{
                name: 'pages.frequency.day.prev',
                value: 0
            }, {
                name: 'pages.frequency.day.today',
                value: 1
            }, {
                name: 'pages.frequency.day.next',
                value: 2
            }, ],
            whichDayS4: [{
                name: 'pages.frequency.day.prev',
                value: 0
            }, {
                name: 'pages.frequency.day.today',
                value: 1
            }, {
                name: 'pages.frequency.day.next',
                value: 2
            }, ],
            whichDayE4: [{
                name: 'pages.frequency.day.prev',
                value: 0
            }, {
                name: 'pages.frequency.day.today',
                value: 1
            }, {
                name: 'pages.frequency.day.next',
                value: 2
            }, ],
            whichDayS5: [{
                name: 'pages.frequency.day.prev',
                value: 0
            }, {
                name: 'pages.frequency.day.today',
                value: 1
            }, {
                name: 'pages.frequency.day.next',
                value: 2
            }, ],
            whichDayE5: [{
                name: 'pages.frequency.day.prev',
                value: 0
            }, {
                name: 'pages.frequency.day.today',
                value: 1
            }, {
                name: 'pages.frequency.day.next',
                value: 2
            }, ],
            startWhichDay: [{
                name: 'pages.frequency.day.prev',
                value: 0
            }, {
                name: 'pages.frequency.day.today',
                value: 1
            }, {
                name: 'pages.frequency.day.next',
                value: 2
            }, ],
            endWhichDay: [{
                name: 'pages.frequency.day.prev',
                value: 0
            }, {
                name: 'pages.frequency.day.today',
                value: 1
            }, {
                name: 'pages.frequency.day.next',
                value: 2
            }, ],
        };
    },
    filters: {
        ascriptionFormat(Type) {
            var Name = '';
            if (Type == '0') {
                Name = that.$t('pages.frequency.day.prev');
            } else if (Type == '1') {
                Name = that.$t('pages.frequency.day.today');
            } else if (Type == '2') {
                Name = that.$t('pages.frequency.day.next');
            }
            return Name;
        }
    },
    created() {
        this.getBalance();
    },
    beforeCreate() {
        that = this;
    },
    methods: {
        saveEdit() {
            this.$refs['frequency'].validate((valid) => {
                if (valid) {
                    if (this.frequency.enabled1 && (this.frequency.startTime1 == null || this.frequency.endTime1 == null)) {
                        this.$notify.warning(this.$t('pages.frequency.warn.timeRequired', { name: this.frequency.pName1 }));
                        return;
                    }
                    if (this.frequency.enabled2 && (this.frequency.startTime2 == null || this.frequency.endTime2 == null)) {
                        this.$notify.warning(this.$t('pages.frequency.warn.timeRequired', { name: this.frequency.pName2 }));
                        return;
                    }
                    if (this.frequency.enabled3 && (this.frequency.startTime3 == null || this.frequency.endTime3 == null)) {
                        this.$notify.warning(this.$t('pages.frequency.warn.timeRequired', { name: this.frequency.pName3 }));
                        return;
                    }
                    if (this.frequency.enabled4 && (this.frequency.startTime4 == null || this.frequency.endTime4 == null)) {
                        this.$notify.warning(this.$t('pages.frequency.warn.timeRequired', { name: this.frequency.pName4 }));
                        return;
                    }
                    if (this.frequency.enabled5 && (this.frequency.startTime5 == null || this.frequency.endTime5 == null)) {
                        this.$notify.warning(this.$t('pages.frequency.warn.timeRequired', { name: this.frequency.pName5 }));
                        return;
                    }
                    this.frequency.enabled1 = this.frequency.enabled1 ? 1 : 0;
                    this.frequency.enabled2 = this.frequency.enabled2 ? 1 : 0;
                    this.frequency.enabled3 = this.frequency.enabled3 ? 1 : 0;
                    this.frequency.enabled4 = this.frequency.enabled4 ? 1 : 0;
                    this.frequency.enabled5 = this.frequency.enabled5 ? 1 : 0;
                    this.frequency.isCustomSettlementDate = this.frequency.isCustomSettlementDate ? true : false;
                    if (this.isadd) {
                        this.$zybhttp
                            .post('Frequency/FrequencyAdd', this.frequency)
                            .then((res) => {
                                if (res.data.status == 0) {
                                    this.$notify.success(this.$t('pages.frequency.addSuccess'));
                                    this.getData();
                                    this.editVisible = false;
                                    this.frequency = {};
                                } else {
                                    this.$notify.error(this.$t('pages.frequency.addFail'));
                                }
                            })
                            .catch((err) => this.$notify.error(this.$t('pages.frequency.addError')));
                    } else {
                        this.$zybhttp
                            .post('Frequency/FrequencyUpdate', this.frequency)
                            .then((res) => {
                                if (res.data.status == 0) {
                                    this.$notify.success(this.$t('pages.frequency.updateSuccess'));
                                    this.getData();
                                    this.editVisible = false;
                                } else {
                                    this.$notify.error(this.$t('pages.frequency.updateFail'));
                                }
                            })
                            .catch((err) => this.$notify.error(this.$t('pages.frequency.updateError')));
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        getData() {
            this.$zybhttp
                .post('Frequency/GetList', this.query)
                .then((res) => {
                    if (res.data.status == 0) {
                        res = res.data;
                        var d = res.data.list;
                        var newdata = d.sort(SortField('id', 'desc'));
                        // for (var i = 0; i < newdata.length; i++) {
                        //     newdata[i]['balanceName'] = this.getBalanceNames(newdata[i]['balanceId']);
                        // }
                        this.frequencys = newdata;
                        this.pageCount = res.data.total || 0;
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.frequency.fetchError')));
        },
        getBalanceNames(ids) {
            var bArr = JSON.parse(JSON.stringify(this.balanceArr));
            var idArr = ids.split(',');
            var condition = '';
            for (var i = 0; i < idArr.length; i++) {
                condition += 'e.id==' + idArr[i] + ' ||';
            }
            var names = bArr
                .filter(function (e) {
                    return eval(condition.substr(0, condition.length - 2));
                })
                .map((item) => item.name)
                .join(',');
            return names;
        },
        getBalance() {
            var serach = {};
            this.$zybhttp
                .post('Balance/GetList', {
                    Field3: '1',
                    Field4: '1'
                })
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data.data.list;
                        this.balanceArr = d.sort(SortField('id', 'asc'));
                        this.getData();
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.frequency.fetchError')));
        },
        handleEdit(id, row) {
            this.frequency = JSON.parse(JSON.stringify(row));
            this.frequency.id = id;
            this.editVisible = true;
            // var d = this.frequency.balanceId.split(',');
            // var arr = [];
            // for (var i = 0; i < d.length; i++) {
            //     arr.push(parseInt(d[i]));
            // }
            // this.frequency.balanceId = arr;
            this.frequency.enabled1 = this.frequency.enabled1 == 1;
            this.frequency.enabled2 = this.frequency.enabled2 == 1;
            this.frequency.enabled3 = this.frequency.enabled3 == 1;
            this.frequency.enabled4 = this.frequency.enabled4 == 1;
            this.frequency.enabled5 = this.frequency.enabled5 == 1;
            this.frequency.isCustomSettlementDate = this.frequency.isCustomSettlementDate == true;
            this.isadd = false;
            this.headTitle = this.$t('pages.frequency.editTitle');
        },
        dbSelected(row) {
            this.frequency = row;
            this.frequency.id = row.id;
            this.editVisible = true;
            this.isadd = false;

            // var d = this.frequency.balanceId.split(',');
            // var arr = [];
            // for (var i = 0; i < d.length; i++) {
            //     arr.push(parseInt(d[i]));
            // }
            // this.frequency.balanceId = arr;
            this.frequency.enabled1 = this.frequency.enabled1 == 1;
            this.frequency.enabled2 = this.frequency.enabled2 == 1;
            this.frequency.enabled3 = this.frequency.enabled3 == 1;
            this.frequency.enabled4 = this.frequency.enabled4 == 1;
            this.frequency.enabled5 = this.frequency.enabled5 == 1;
            this.frequency.isCustomSettlementDate = this.frequency.isCustomSettlementDate == true;
            this.headTitle = this.$t('pages.frequency.editTitle');
            // console.log(row);
        },
        handleShow(index, row) {
            this.frequency = row;
            this.viewVisible = true;
        },
        handleAdd() {
            var ms_userInfo = localStorage.getItem('ms_userInfo');
            var userinfo = JSON.parse(ms_userInfo);
            this.frequency = {};
            this.isadd = true;
            let date = new Date();
            this.frequency.ascription = '1';
            // this.frequency.CreateDate = dateFormat.formatDate(date, 'yyyy-MM-dd hh:mm:ss');
            this.frequency.createUserId = userinfo.loginId;
            this.frequency.modifyUserId = userinfo.loginId;
            //this.frequency.isUse =true;
            this.editVisible = true;
            this.headTitle = this.$t('pages.frequency.addTitle');
        },
        handlePageChange(val) {
            this.$set(this.query, 'PageIndex', val);
            this.getData();
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
            let str = '';
            let strValue = '';
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                str += this.multipleSelection[i].name + ' ';
                strValue += this.multipleSelection[i].id + ',';
            }
            if (strValue.length == 0) {
                this.$notify.warning(this.$t('pages.frequency.warn.selectToDelete'));
                return;
            }
            this.$confirm(this.$t('pages.frequency.confirmDelete'), this.$t('pages.frequency.tip'), {
                    type: 'warning'
                })
                .then(() => {
                    this.$zybhttp
                        //.get('Frequency/FrequencyDel?ids=1')
                        .get('Frequency/FrequencyDel', {
                            params: {
                                ids: strValue
                            }
                        })
                        .then((res) => {
                            if (res.data.status == 0) {
                                this.$notify.success(this.$t('pages.frequency.deleteSuccess', { names: str }));
                                this.getData();
                            } else {
                                this.$notify.error(res.data.msg);
                            }
                        })
                        .catch((err) => this.$notify.error(this.$t('pages.frequency.deleteError')));
                    this.multipleSelection = [];
                })
                .catch(() => {});
        },
        indexMethod(index) {
            return index + 1;
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 200px;
}

.handle-headleft {
    float: left;
    margin-bottom: 15px;
}

.handle-headright {
    float: right;
    margin-bottom: 15px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.size-full {
    width: 100%;
}
</style>
